import { PassInterface, PassStatusEnum } from '../../..';

export class UpdatePassStatusRequestDto implements PassInterface {
  status: PassStatusEnum;
}
